module.exports = __webpack_public_path__ + "img/checkin.943e6fcb.svg";